import type {TableDataType} from '../../components/react_table/table-data-type'
import type {Column, ColumnInstance, V7Column, V7ColumnInstance} from './types'

export const getColumnModel = (column: Column<TableDataType> | ColumnInstance<TableDataType>) => {
  if (isV7Column(column)) {
    return column.columnModel
  }
  return undefined
}

// V7Column has uppercase 'Cell' property
// V8Column has lowercase 'cell' property
const isV7Column = (
  column: Column<TableDataType> | ColumnInstance<TableDataType>,
): column is V7Column<TableDataType> | V7ColumnInstance => {
  return 'Cell' in column
}
